import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import FormControl from '@material-ui/core/FormControl';
import DialogTitle from '@material-ui/core/DialogTitle';
import SvgIcon from '@material-ui/core/SvgIcon';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import BarHeat from '../../components/heat_graph/barGraph';
import PlaneHeat from '../../components/heat_graph/planeGraph';
import DeltaTHeat from '../../components/heat_graph/deltaTGraph';

import Config from '../../constants/appConfig';
import MaterialIcon from './../../components/MaterialIcon';
import { notification } from 'antd';

import { useParams } from "react-router";
import InputAdornment from '@material-ui/core/InputAdornment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { FormatTextdirectionRToLSharp } from '@material-ui/icons';
import tools from '../../components/util/tools'

import Units from '../../components/util/units';
const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

class Edit extends React.Component {

  state = {
    id: this.props.id,
    name: '',
    type: '',

    checkAutoPlan: false,
    checkAutoMerge: false,
    checkAlignPivot: false,
    checkAutoSend: false,
    checkAutoShare: false,
    checkAutoReturn: false,
    checkAutoMatch: false,

    checkMapaFundoMapa: true,
    checkAplicacaoMapa: true,
    checkTrajetoriaMapa: true,
    checkRemoverLogoMapa: false,
    checkGuiaAplicacaoMapa: false,

    alturaMargemDown: { value: Units.convertLengthTo(1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(-1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaMargemUp: { value: Units.convertLengthTo(1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaLimiteDown: { value: Units.convertLengthTo(1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(-2, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaLimiteUp: { value: Units.convertLengthTo(1, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), text: Units.convertLengthTo(2, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)), valid: true },
    alturaSet: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 7 : 4, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)),

    fluxoMargemDown: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? -.5 : -2, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoMargemUp: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoLimiteDown: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 3, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? -1 : -5, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoLimiteUp: { value: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? .5 : 3, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), text: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 1 : 5, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)), valid: true },
    fluxoSet: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 2 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)),

    velocidadeMargemDown: { value: Units.convertSpeed(10, 'km/h', this.props.res), text: Units.convertSpeed(-10, 'km/h', this.props.res), valid: true },
    velocidadeMargemUp: { value: Units.convertSpeed(10, 'km/h', this.props.res), text: Units.convertSpeed(10, 'km/h', this.props.res), valid: true },
    velocidadeLimiteDown: { value: Units.convertSpeed(20, 'km/h', this.props.res), text: Units.convertSpeed(-30, 'km/h', this.props.res), valid: true },
    velocidadeLimiteUp: { value: Units.convertSpeed(20, 'km/h', this.props.res), text: Units.convertSpeed(30, 'km/h', this.props.res), valid: true },
    velocidadeSet: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 110 : 180, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),

    velocidadeVMargemDown: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 4 : 8, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 2 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVMargemUp: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 4 : 8, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 10 : 18, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVLimiteDown: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 2 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 0 : 0, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVLimiteUp: { value: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 10 : 12, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), text: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 20 : 30, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)), valid: true },
    velocidadeVSet: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 6 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),


    espelharAnguloV: true,
    anguloVMargemDown: { value: 50, text: 50, valid: true },
    anguloVMargemUp: { value: 50, text: 50, valid: true },
    anguloVLimiteDown: { value: 20, text: 70, valid: true },
    anguloVLimiteUp: { value: 20, text: 70, valid: true },
    anguloVSet: 0,


    temperaturaMargemDown: this.props.res.LINGUA === 'en-US' ? { value: 31.5, text: 41, valid: true } : { value: 17.5, text: 5, valid: true },
    temperaturaMargemUp: this.props.res.LINGUA === 'en-US' ? { value: 31.5, text: 104, valid: true } : { value: 17.5, text: 40, valid: true },
    temperaturaLimiteDown: this.props.res.LINGUA === 'en-US' ? { value: 9, text: 32, valid: true } : { value: 5, text: 0, valid: true },
    temperaturaLimiteUp: this.props.res.LINGUA === 'en-US' ? { value: 18, text: 122, valid: true } : { value: 10, text: 50, valid: true },
    temperaturaSet: this.props.res.LINGUA === 'en-US' ? 72.5 : 22.5,


    UmidadeMargemDown: { value: 37.5, text: 15, valid: true },
    UmidadeMargemUp: { value: 37.5, text: 90, valid: true },
    UmidadeLimiteDown: { value: 5, text: 10, valid: true },
    UmidadeLimiteUp: { value: 10, text: 100, valid: true },
    UmidadeSet: 52.5,


    //-----

    checkConfig: [0, 0, 0, 0, 0],

    checkResumoTitulo: true,
    checkResumoCliente: true,
    checkResumoPropriedade: true,
    checkResumoArea: true,
    checkResumoFaixa: true,
    checkResumoVazao: true,
    checkResumoInicio: true,
    checkResumoFim: true,
    checkResumoAeronave: true,
    checkResumoPiloto: true,
    checkResumoTalhoes: true,
    checkResumoLatLng: true,
    checkResumoAlturaCultura: true,
    checkWhatsAppAplicacao: true,
    checkTrajetoria: true,
    checkPoligono: true,
    checkPoligonoLimpo: true,
    checkMapa: true,
    checkCoordenadas: true,
    checkVazao: true,
    checkVolume: true,
    checkAltura: true,
    checkCliente: true,
    checkAeronave: true,
    checkClima: true,
    checkVelocidade: true,
    checkFaixa: true,
    checkEstenderTiro: false,

    checkWhatsAppQuali: true,
    checkResumoCobertura: true,
    checkResumoAltura: true,
    checkResumoFluxo: true,
    checkResumoVelocidade: true,
    checkResumoVelocidadeVento: true,
    checkResumoAnguloVento: true,
    checkResumoTemperatura: true,
    checkResumoUmidade: true,
    checkResumoDeltat: true,

    larguraExd: 100,

    planningStrategyMode: 'tempo',
    planningStrategyRanges: {
      BACKTOBACK: { min: '', max: '' },
      SKIPBACKTOBACK: { min: '', max: '' },
      RACETRACK: { min: '', max: '' },
      QUICKRACETRACK: { min: '', max: '' },
      REVERSERACETRACK: { min: '', max: '' },
      SQUEEZE: { min: '', max: '' },
      EXPAND: { min: '', max: '' }
    },
  };

  componentDidMount() {
    let automationType = localStorage.getItem('automationType') || '';
    this.setState({ type: automationType });

    if (!this.state.id) {
      this.applyDefaultsByType(automationType);
      return;
    }

    const apiUrl = Config.server + '/profile_auto/' + this.state.id;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result.length > 0) {
            let state = { ...this.state };

            if (result[0].type === 'analise') {
              state.name = result[0].name;
              state.type = result[0].type;
              state.checkWhatsAppQuali = result[0].rel_config?.checkWhatsAppQuali ?? true;
              state.checkResumoCobertura = result[0].rel_config?.checkResumoCobertura ?? true;
              state.checkResumoAltura = result[0].rel_config?.checkResumoAltura ?? true;
              state.checkResumoFluxo = result[0].rel_config?.checkResumoFluxo ?? true;
              state.checkResumoVelocidade = result[0].rel_config?.checkResumoVelocidade ?? true;
              state.checkResumoVelocidadeVento = result[0].rel_config?.checkResumoVelocidadeVento ?? true;
              state.checkResumoAnguloVento = result[0].rel_config?.checkResumoAnguloVento ?? true;
              state.checkResumoTemperatura = result[0].rel_config?.checkResumoTemperatura ?? true;
              state.checkResumoUmidade = result[0].rel_config?.checkResumoUmidade ?? true;
              state.checkResumoDeltat = result[0].rel_config?.checkResumoDeltat ?? true;
              state.larguraExd = result[0].rel_config?.larguraExd ?? 100;
              for (let i = 0; i < result[0].params.length; i++) {
                const element = result[0].params[i];
                if (element.type === 'altura') {
                  if (element.set_a) {
                    state.alturaSet = Units.convertLength(element.set_a, 'm', this.props.res);
                    state.checkConfig[0] = 1;
                  }
                  state.alturaMargemDown.value = Units.convertLength(element.margin_down, 'm', this.props.res);
                  state.alturaMargemDown.text = tools.round(Units.convertLength(element.set_a - element.margin_down, 'm', this.props.res), 2);
                  state.alturaMargemUp.value = Units.convertLength(element.margin_up, 'm', this.props.res);
                  state.alturaMargemUp.text = tools.round(Units.convertLength(element.set_a + element.margin_up, 'm', this.props.res), 2);
                  state.alturaLimiteDown.value = Units.convertLength(element.limit_down, 'm', this.props.res);
                  state.alturaLimiteDown.text = tools.round(Units.convertLength(element.set_a - element.margin_down - element.limit_down, 'm', this.props.res), 2);
                  state.alturaLimiteUp.value = Units.convertLength(element.limit_up, 'm', this.props.res);
                  state.alturaLimiteUp.text = tools.round(Units.convertLength(element.set_a + element.margin_up + element.limit_up, 'm', this.props.res), 2);
                } else if (element.type === 'fluxo') {
                  if (element.set_a) {
                    state.fluxoSet = Units.convertFlow(element.set_a, 'L', 'ha', this.props.res);
                    state.checkConfig[2] = 1;
                  }
                  state.fluxoMargemDown.value = Units.convertFlow(element.margin_down, 'L', 'ha', this.props.res);
                  state.fluxoMargemDown.text = tools.round(Units.convertFlow(element.set_a - element.margin_down, 'L', 'ha', this.props.res), 2);
                  state.fluxoMargemUp.value = Units.convertFlow(element.margin_up, 'L', 'ha', this.props.res);
                  state.fluxoMargemUp.text = tools.round(Units.convertFlow(element.set_a + element.margin_up, 'L', 'ha', this.props.res), 2);
                  state.fluxoLimiteDown.value = Units.convertFlow(element.limit_down, 'L', 'ha', this.props.res);
                  state.fluxoLimiteDown.text = tools.round(Units.convertFlow(element.set_a - element.margin_down - element.limit_down, 'L', 'ha', this.props.res), 2);
                  state.fluxoLimiteUp.value = Units.convertFlow(element.limit_up, 'L', 'ha', this.props.res);
                  state.fluxoLimiteUp.text = tools.round(Units.convertFlow(element.set_a + element.margin_up + element.limit_up, 'L', 'ha', this.props.res), 2);
                } else if (element.type === 'velocidade') {
                  if (element.set_a) {
                    state.velocidadeSet = Units.convertSpeed(element.set_a, 'km/h', this.props.res);
                    state.checkConfig[1] = 1;
                  }
                  state.velocidadeMargemDown.value = Units.convertSpeed(element.margin_down, 'km/h', this.props.res);
                  state.velocidadeMargemDown.text = tools.round(Units.convertSpeed(element.set_a - element.margin_down, 'km/h', this.props.res), 2);
                  state.velocidadeMargemUp.value = Units.convertSpeed(element.margin_up, 'km/h', this.props.res);
                  state.velocidadeMargemUp.text = tools.round(Units.convertSpeed(element.set_a + element.margin_up, 'km/h', this.props.res), 2);
                  state.velocidadeLimiteDown.value = Units.convertSpeed(element.limit_down, 'km/h', this.props.res);
                  state.velocidadeLimiteDown.text = tools.round(Units.convertSpeed(element.set_a - element.margin_down - element.limit_down, 'km/h', this.props.res), 2);
                  state.velocidadeLimiteUp.value = Units.convertSpeed(element.limit_up, 'km/h', this.props.res);
                  state.velocidadeLimiteUp.text = tools.round(Units.convertSpeed(element.set_a + element.margin_up + element.limit_up, 'km/h', this.props.res), 2);
                } else if (element.type === 'velocidadeV') {
                  state.velocidadeVMargemDown.value = Units.convertSpeed(element.margin_down, 'km/h', this.props.res);
                  state.velocidadeVMargemDown.text = tools.round(Units.convertSpeed(element.set_a - element.margin_down, 'km/h', this.props.res), 2);
                  state.velocidadeVMargemUp.value = Units.convertSpeed(element.margin_up, 'km/h', this.props.res);
                  state.velocidadeVMargemUp.text = tools.round(Units.convertSpeed(element.set_a + element.margin_up, 'km/h', this.props.res), 2);
                  state.velocidadeVLimiteDown.value = Units.convertSpeed(element.limit_down, 'km/h', this.props.res);
                  state.velocidadeVLimiteDown.text = tools.round(Units.convertSpeed(element.set_a - element.margin_down - element.limit_down, 'km/h', this.props.res), 2);
                  state.velocidadeVLimiteUp.value = Units.convertSpeed(element.limit_up, 'km/h', this.props.res);
                  state.velocidadeVLimiteUp.text = tools.round(Units.convertSpeed(element.set_a + element.margin_up + element.limit_up, 'km/h', this.props.res), 2);
                  state.velocidadeVSet = Units.convertSpeed(element.set_a, 'km/h', this.props.res);
                } else if (element.type === 'angulo') {
                  state.anguloVMargemDown.value = element.margin_down;
                  state.anguloVMargemDown.text = element.margin_down;
                  state.anguloVMargemUp.value = element.margin_up;
                  state.anguloVMargemUp.text = element.margin_up;
                  state.anguloVLimiteDown.value = element.limit_down;
                  state.anguloVLimiteDown.text = element.margin_down + element.limit_down;
                  state.anguloVLimiteUp.value = element.limit_up;
                  state.anguloVLimiteUp.text = element.margin_up + element.limit_up;
                  if (state.anguloVLimiteUp.value !== state.anguloVLimiteDown.value ||
                    state.anguloVMargemUp.value !== state.anguloVMargemDown.value) {
                    state.espelharAnguloV = false;
                  }
                } else if (element.type === 'temperatura') {
                  if (this.props.res.LINGUA === 'en-US') {
                    state.temperaturaSet = tools.c_to_f(element.set_a);
                    state.temperaturaMargemDown.value = state.temperaturaSet - tools.c_to_f(element.set_a - element.margin_down);
                    state.temperaturaMargemDown.text = tools.round(tools.c_to_f(element.set_a - element.margin_down), 2);
                    state.temperaturaMargemUp.value = tools.c_to_f(element.set_a + element.margin_up) - state.temperaturaSet;
                    state.temperaturaMargemUp.text = tools.round(tools.c_to_f(element.set_a + element.margin_up), 2);
                    state.temperaturaLimiteDown.value = state.temperaturaSet - state.temperaturaMargemDown.value -
                      tools.c_to_f(element.set_a - element.margin_down - element.limit_down);
                    state.temperaturaLimiteDown.text = tools.round(tools.c_to_f(element.set_a - element.margin_down - element.limit_down), 2);
                    state.temperaturaLimiteUp.value = tools.c_to_f(element.set_a + element.margin_up + element.limit_up) -
                      state.temperaturaSet - state.temperaturaMargemUp.value;
                    state.temperaturaLimiteUp.text = tools.round(tools.c_to_f(element.set_a + element.margin_up + element.limit_up), 2);
                  } else {
                    state.temperaturaSet = element.set_a;
                    state.temperaturaMargemDown.value = element.margin_down;
                    state.temperaturaMargemDown.text = element.set_a - element.margin_down;
                    state.temperaturaMargemUp.value = element.margin_up;
                    state.temperaturaMargemUp.text = element.set_a + element.margin_up;
                    state.temperaturaLimiteDown.value = element.limit_down;
                    state.temperaturaLimiteDown.text = element.set_a - element.margin_down - element.limit_down;
                    state.temperaturaLimiteUp.value = element.limit_up;
                    state.temperaturaLimiteUp.text = element.set_a + element.margin_up + element.limit_up;
                  }
                } else if (element.type === 'umidade') {
                  state.UmidadeSet = element.set_a;
                  state.UmidadeMargemDown.value = element.margin_down;
                  state.UmidadeMargemDown.text = element.set_a - element.margin_down;
                  state.UmidadeMargemUp.value = element.margin_up;
                  state.UmidadeMargemUp.text = element.set_a + element.margin_up;
                  state.UmidadeLimiteDown.value = element.limit_down;
                  state.UmidadeLimiteDown.text = element.set_a - element.margin_down - element.limit_down;
                  state.UmidadeLimiteUp.value = element.limit_up;
                  state.UmidadeLimiteUp.text = element.set_a + element.margin_up + element.limit_up;
                }

              }
              this.setState(state);
            } else if (result[0].type === 'aplicacao') {
              const param = result[0]?.params?.[0];

              state.name = result[0].name;
              state.type = result[0].type;

              var rawPerc = (param && param.perc !== undefined && param.perc !== null) ? param.perc : 100;
              var percNum = Number(rawPerc);
              state.percSize = isFinite(percNum) ? percNum : 100;

              let resumo = {};
              try {
                const configStr = param?.resumo_config;
                resumo = configStr && configStr !== 'undefined' ? JSON.parse(configStr) : {};
              } catch (e) {
                resumo = {};
              }

              state.checkResumoTitulo = resumo?.checkResumoTitulo ?? true;
              state.checkResumoCliente = resumo?.checkResumoCliente ?? true;
              state.checkResumoPropriedade = resumo?.checkResumoPropriedade ?? true;
              state.checkResumoArea = resumo?.checkResumoArea ?? true;
              state.checkResumoFaixa = resumo?.checkResumoFaixa ?? true;
              state.checkResumoVazao = resumo?.checkResumoVazao ?? true;
              state.checkResumoInicio = resumo?.checkResumoInicio ?? true;
              state.checkResumoFim = resumo?.checkResumoFim ?? true;
              state.checkResumoAeronave = resumo?.checkResumoAeronave ?? true;
              state.checkResumoPiloto = resumo?.checkResumoPiloto ?? true;
              state.checkResumoTalhoes = resumo?.checkResumoTalhoes ?? true;
              state.checkResumoLatLng = resumo?.checkResumoLatLng ?? true;
              state.checkResumoAlturaCultura = resumo?.checkResumoAlturaCultura ?? true;
              state.checkWhatsAppAplicacao = resumo?.checkWhatsAppAplicacao ?? true;
              state.checkTrajetoria = resumo?.checkTrajetoria ?? true;
              state.checkPoligono = resumo?.checkPoligono ?? true;
              state.checkPoligonoLimpo = resumo?.checkPoligonoLimpo ?? true;
              state.checkMapa = resumo?.checkMapa ?? true;
              state.checkCoordenadas = resumo?.checkCoordenadas ?? true;
              state.checkVazao = resumo?.checkVazao ?? true;
              state.checkVolume = resumo?.checkVolume ?? true;
              state.checkAltura = resumo?.checkAltura ?? true;
              state.checkCliente = resumo?.checkCliente ?? true;
              state.checkAeronave = resumo?.checkAeronave ?? true;
              state.checkClima = resumo?.checkClima ?? true;
              state.checkVelocidade = resumo?.checkVelocidade ?? true;
              state.checkFaixa = resumo?.checkFaixa ?? true;
              state.checkEstenderTiro = resumo?.checkEstenderTiro ?? false;

              this.setState(state);
            } else if (result[0].type === 'planejamento') {
              const param = result[0]?.params?.[0];

              state.name = result[0].name;
              state.title = result[0].title || '';
              state.type = result[0].type;

              let resumo = {};
              try {
                const configStr = param?.resumo_config;
                resumo = configStr && configStr !== 'undefined' ? JSON.parse(configStr) : {};
              } catch (e) {
                resumo = {};
              }

              state.checkAutoPlan = resumo?.checkAutoPlan ?? false;
              state.checkAutoMerge = resumo?.checkAutoMerge ?? false;
              state.checkAlignPivot = resumo?.checkAlignPivot ?? false;
              state.checkAutoSend = resumo?.checkAutoSend ?? false;
              state.checkAutoMatch = resumo?.checkAutoMatch ?? false;
              state.planningStrategyMode = resumo?.planningStrategyMode ?? 'tempo';
              state.planningStrategyRanges = resumo?.planningStrategyRanges ?? {
                BACKTOBACK: { min: '', max: '' },
                SKIPBACKTOBACK: { min: '', max: '' },
                RACETRACK: { min: '', max: '' },
                QUICKRACETRACK: { min: '', max: '' },
                REVERSERACETRACK: { min: '', max: '' },
                SQUEEZE: { min: '', max: '' },
                EXPAND: { min: '', max: '' }
              };

              this.setState(state);
            } else if (result[0].type === 'relatorio_mapa') {
              const param = result[0]?.params?.[0];

              state.name = result[0].name;
              state.title = result[0].title || '';
              state.type = result[0].type;

              let resumo = {};
              try {
                const configStr = param?.resumo_config;
                resumo = configStr && configStr !== 'undefined' ? JSON.parse(configStr) : {};
              } catch (e) {
                resumo = {};
              }

              state.checkMapaFundoMapa = resumo?.checkMapaFundoMapa ?? true;
              state.checkAplicacaoMapa = resumo?.checkAplicacaoMapa ?? true;
              state.checkTrajetoriaMapa = resumo?.checkTrajetoriaMapa ?? true;
              state.checkRemoverLogoMapa = resumo?.checkRemoverLogoMapa ?? false;
              state.checkGuiaAplicacaoMapa = resumo?.checkGuiaAplicacaoMapa ?? false;

              this.setState(state);
            } else if (result[0].type === 'ordem_servico') {
              const param = result[0]?.params?.[0];

              state.name = result[0].name;
              state.title = result[0].title || '';
              state.type = result[0].type;

              let resumo = {};
              try {
                const configStr = param?.resumo_config;
                resumo = configStr && configStr !== 'undefined' ? JSON.parse(configStr) : {};
              } catch (e) {
                resumo = {};
              }

              state.checkAutoShare = resumo?.checkAutoShare ?? false;
              state.checkAutoReturn = resumo?.checkAutoReturn ?? false;

              this.setState(state);
            }
          }
        },
        (error) => {
          if (error.status === 401) {
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  }

  applyDefaultsByType = (type) => {
    let state = { ...this.state };

    state.type = type || '';

    if (type === 'aplicacao') {
      state.percSize = isFinite(Number(state.percSize)) ? Number(state.percSize) : 100;

      state.checkResumoTitulo = true;
      state.checkResumoCliente = true;
      state.checkResumoPropriedade = true;
      state.checkResumoArea = true;
      state.checkResumoFaixa = true;
      state.checkResumoVazao = true;
      state.checkResumoInicio = true;
      state.checkResumoFim = true;
      state.checkResumoAeronave = true;
      state.checkResumoPiloto = true;
      state.checkResumoTalhoes = true;
      state.checkResumoLatLng = true;
      state.checkResumoAlturaCultura = true;
      state.checkWhatsAppAplicacao = true;
      state.checkTrajetoria = true;
      state.checkPoligono = true;
      state.checkPoligonoLimpo = true;
      state.checkMapa = true;
      state.checkCoordenadas = true;
      state.checkVazao = true;
      state.checkVolume = true;
      state.checkAltura = true;
      state.checkCliente = true;
      state.checkAeronave = true;
      state.checkClima = true;
      state.checkVelocidade = true;
      state.checkFaixa = true;
      state.checkEstenderTiro = false;
    } else if (type === 'planejamento') {
      state.checkAutoPlan = false;
      state.checkAutoMerge = false;
      state.checkAlignPivot = false;
      state.checkAutoSend = false;
      state.checkAutoMatch = false;
      state.title = state.title || '';
      state.planningStrategyMode = 'tempo';
      state.planningStrategyRanges = {
        BACKTOBACK: { min: '', max: '' },
        SKIPBACKTOBACK: { min: '', max: '' },
        RACETRACK: { min: '', max: '' },
        QUICKRACETRACK: { min: '', max: '' },
        REVERSERACETRACK: { min: '', max: '' },
        SQUEEZE: { min: '', max: '' },
        EXPAND: { min: '', max: '' }
      };
    } else if (type === 'ordem_servico') {
      state.checkAutoShare = false;
      state.checkAutoReturn = false;
      state.title = state.title || '';
    } else if (type === 'relatorio_mapa') {
      state.checkMapaFundoMapa = true;
      state.checkAplicacaoMapa = true;
      state.checkTrajetoriaMapa = true;
      state.checkRemoverLogoMapa = false;
      state.checkGuiaAplicacaoMapa = false;
      state.title = state.title || '';
    } else if (type === 'analise') {
      state.checkWhatsAppQuali = true;
      state.checkResumoCobertura = true;
      state.checkResumoAltura = true;
      state.checkResumoFluxo = true;
      state.checkResumoVelocidade = true;
      state.checkResumoVelocidadeVento = true;
      state.checkResumoAnguloVento = true;
      state.checkResumoTemperatura = true;
      state.checkResumoUmidade = true;
      state.checkResumoDeltat = true;
      state.larguraExd = isFinite(Number(state.larguraExd)) ? Number(state.larguraExd) : 100;
    }

    this.setState(state);
  };


  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    let method = 'POST';
    let apiUrl = Config.server + '/profile_auto';
    if (this.state.id) {
      apiUrl += `/${this.state.id}`;
      method = 'PUT';
    }

    let json;

    if (this.state.type === 'aplicacao') {
      const resumo_config = {
        checkResumoTitulo: this.state.checkResumoTitulo,
        checkResumoCliente: this.state.checkResumoCliente,
        checkResumoPropriedade: this.state.checkResumoPropriedade,
        checkResumoArea: this.state.checkResumoArea,
        checkResumoFaixa: this.state.checkResumoFaixa,
        checkResumoVazao: this.state.checkResumoVazao,
        checkResumoInicio: this.state.checkResumoInicio,
        checkResumoFim: this.state.checkResumoFim,
        checkResumoAeronave: this.state.checkResumoAeronave,
        checkResumoPiloto: this.state.checkResumoPiloto,
        checkResumoTalhoes: this.state.checkResumoTalhoes,
        checkResumoLatLng: this.state.checkResumoLatLng,
        checkResumoAlturaCultura: this.state.checkResumoAlturaCultura,
        checkWhatsAppAplicacao: this.state.checkWhatsAppAplicacao,
        checkTrajetoria: this.state.checkTrajetoria,
        checkPoligono: this.state.checkPoligono,
        checkPoligonoLimpo: this.state.checkPoligonoLimpo,
        checkMapa: this.state.checkMapa,
        checkCoordenadas: this.state.checkCoordenadas,
        checkVazao: this.state.checkVazao,
        checkVolume: this.state.checkVolume,
        checkAltura: this.state.checkAltura,
        checkCliente: this.state.checkCliente,
        checkAeronave: this.state.checkAeronave,
        checkClima: this.state.checkClima,
        checkVelocidade: this.state.checkVelocidade,
        checkFaixa: this.state.checkFaixa,
        checkEstenderTiro: this.state.checkEstenderTiro,
      };

      json = {
        name: this.state.name,
        type: 'aplicacao',
        params: [
          {
            perc: this.state.percSize,
            resumo_config: resumo_config,
          }
        ]
      };
    } else if (this.state.type === 'planejamento') {

      let planningStrategyRangesToSave = this.state.planningStrategyRanges;

      if (this.state.planningStrategyMode === 'faixas') {
        const planningStrategyRanges = { ...(this.state.planningStrategyRanges || {}) };
        const strategyKeys = Object.keys(planningStrategyRanges);
        const intervals = [];
        let hasUpdatedRanges = false;

        for (let i = 0; i < strategyKeys.length; i++) {
          const strategyKey = strategyKeys[i];
          const strategyRange = { ...(planningStrategyRanges[strategyKey] || {}) };

          const hasMin = strategyRange.min !== '' && strategyRange.min !== null && strategyRange.min !== undefined;
          const hasMax = strategyRange.max !== '' && strategyRange.max !== null && strategyRange.max !== undefined;

          if (hasMin && !hasMax && !strategyRange.noMax) {
            strategyRange.noMax = true;
            planningStrategyRanges[strategyKey] = strategyRange;
            hasUpdatedRanges = true;
          }

          if (!hasMin && !hasMax) {
            continue;
          }

          if (!hasMin) {
            if (hasUpdatedRanges) {
              this.setState({ planningStrategyRanges: planningStrategyRanges });
            }

            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.DEFINIR_MINIMO_ESTRATEGIA,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
          }

          const minValue = Number(strategyRange.min);
          const maxValue = hasMax ? Number(strategyRange.max) : null;

          if (
            isNaN(minValue) ||
            (hasMax && isNaN(maxValue)) ||
            (hasMax && minValue > maxValue)
          ) {
            if (hasUpdatedRanges) {
              this.setState({ planningStrategyRanges: planningStrategyRanges });
            }

            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.INTERVALO_ESTRATEGIA_INVALIDO,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
          }

          intervals.push({
            strategyKey: strategyKey,
            min: minValue,
            max: maxValue,
            noMax: !hasMax || !!strategyRange.noMax
          });
        }

        if (intervals.length === 0) {
          if (hasUpdatedRanges) {
            this.setState({ planningStrategyRanges: planningStrategyRanges });
          }

          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.DEFINIR_INTERVALO_ESTRATEGIA,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
          return;
        }

        for (let i = 0; i < intervals.length; i++) {
          for (let j = i + 1; j < intervals.length; j++) {
            const currentInterval = intervals[i];
            const nextInterval = intervals[j];

            const currentMax = currentInterval.noMax ? null : currentInterval.max;
            const nextMax = nextInterval.noMax ? null : nextInterval.max;

            const hasOverlap =
              (currentMax === null || nextInterval.min <= currentMax) &&
              (nextMax === null || currentInterval.min <= nextMax);

            if (hasOverlap) {
              if (hasUpdatedRanges) {
                this.setState({ planningStrategyRanges: planningStrategyRanges });
              }

              notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.INTERVALO_EXISTENTE,
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
              return;
            }
          }
        }

        planningStrategyRangesToSave = planningStrategyRanges;

        if (hasUpdatedRanges) {
          this.setState({ planningStrategyRanges: planningStrategyRanges });
        }
      }

      const resumo_config_planejamento = {
        checkAutoPlan: this.state.checkAutoPlan,
        checkAutoMerge: this.state.checkAutoMerge,
        checkAlignPivot: this.state.checkAlignPivot,
        checkAutoSend: this.state.checkAutoSend,
        checkAutoMatch: this.state.checkAutoMatch,
        planningStrategyMode: this.state.planningStrategyMode,
        planningStrategyRanges: planningStrategyRangesToSave
      };

      json = {
        name: this.state.name,
        title: this.state.title,
        type: 'planejamento',
        params: [
          {
            resumo_config: resumo_config_planejamento
          }
        ]
      };

    } else if (this.state.type === 'ordem_servico') {
      const resumo_config_ordem_servico = {
        checkAutoShare: this.state.checkAutoShare,
        checkAutoReturn: this.state.checkAutoReturn
      };

      json = {
        name: this.state.name,
        title: this.state.title,
        type: 'ordem_servico',
        params: [
          {
            resumo_config: resumo_config_ordem_servico
          }
        ]
      };

    } else if (this.state.type === 'relatorio_mapa') {
      const resumo_config_relatorio_mapa = {
        checkMapaFundoMapa: this.state.checkMapaFundoMapa,
        checkAplicacaoMapa: this.state.checkAplicacaoMapa,
        checkTrajetoriaMapa: this.state.checkTrajetoriaMapa,
        checkRemoverLogoMapa: this.state.checkRemoverLogoMapa,
        checkGuiaAplicacaoMapa: this.state.checkGuiaAplicacaoMapa
      };

      json = {
        name: this.state.name,
        title: this.state.title,
        type: 'relatorio_mapa',
        params: [
          {
            resumo_config: resumo_config_relatorio_mapa
          }
        ]
      };

    } else {
      if (this.state.type === 'analise') {
        if (
          !this.state.name ||
          !this.state.alturaMargemDown.valid ||
          !this.state.alturaMargemUp.valid ||
          !this.state.alturaLimiteDown.valid ||
          !this.state.alturaLimiteUp.valid ||
          !this.state.fluxoMargemDown.valid ||
          !this.state.fluxoMargemUp.valid ||
          !this.state.fluxoLimiteDown.valid ||
          !this.state.fluxoLimiteUp.valid ||
          !this.state.velocidadeMargemDown.valid ||
          !this.state.velocidadeMargemUp.valid ||
          !this.state.velocidadeLimiteDown.valid ||
          !this.state.velocidadeLimiteUp.valid ||
          !this.state.velocidadeVMargemDown.valid ||
          !this.state.velocidadeVMargemUp.valid ||
          !this.state.velocidadeVLimiteDown.valid ||
          !this.state.velocidadeVLimiteUp.valid ||
          (!this.state.espelharAnguloV && !this.state.anguloVMargemDown.valid) ||
          !this.state.anguloVMargemUp.valid ||
          (!this.state.espelharAnguloV && !this.state.anguloVLimiteDown.valid) ||
          !this.state.anguloVLimiteUp.valid ||
          !this.state.temperaturaMargemDown.valid ||
          !this.state.temperaturaMargemUp.valid ||
          !this.state.temperaturaLimiteDown.valid ||
          !this.state.temperaturaLimiteUp.valid ||
          !this.state.UmidadeMargemDown.valid ||
          !this.state.UmidadeMargemUp.valid ||
          !this.state.UmidadeLimiteDown.valid ||
          !this.state.UmidadeLimiteUp.valid
        ) {
          notification.open({
            message: this.props.res.CONFIG_INVALID,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
          return;
        }
      }

      const rel_config = {
        checkWhatsAppQuali: this.state.checkWhatsAppQuali,
        checkResumoCobertura: this.state.checkResumoCobertura,
        checkResumoAltura: this.state.checkResumoAltura,
        checkResumoFluxo: this.state.checkResumoFluxo,
        checkResumoVelocidade: this.state.checkResumoVelocidade,
        checkResumoVelocidadeVento: this.state.checkResumoVelocidadeVento,
        checkResumoAnguloVento: this.state.checkResumoAnguloVento,
        checkResumoTemperatura: this.state.checkResumoTemperatura,
        checkResumoUmidade: this.state.checkResumoUmidade,
        checkResumoDeltat: this.state.checkResumoDeltat,
        larguraExd: this.state.larguraExd
      };

      const params = [
        {
          type: 'altura',
          set_a: this.state.checkConfig[0] ? Units.toCanonicalLength(this.state.alturaSet, this.props.res) : 0,
          margin_up: Units.toCanonicalLength(this.state.alturaMargemUp.value, this.props.res),
          margin_down: Units.toCanonicalLength(this.state.alturaMargemDown.value, this.props.res),
          limit_up: Units.toCanonicalLength(this.state.alturaLimiteUp.value, this.props.res),
          limit_down: Units.toCanonicalLength(this.state.alturaLimiteDown.value, this.props.res),
        },
        {
          type: 'fluxo',
          set_a: this.state.checkConfig[2] ? Units.toCanonicalFlow(this.state.fluxoSet, this.props.res, 'L', 'ha') : 0,
          margin_up: Units.toCanonicalFlow(this.state.fluxoMargemUp.value, this.props.res, 'L', 'ha'),
          margin_down: Units.toCanonicalFlow(this.state.fluxoMargemDown.value, this.props.res, 'L', 'ha'),
          limit_up: Units.toCanonicalFlow(this.state.fluxoLimiteUp.value, this.props.res, 'L', 'ha'),
          limit_down: Units.toCanonicalFlow(this.state.fluxoLimiteDown.value, this.props.res, 'L', 'ha'),
        },
        {
          type: 'velocidade',
          set_a: this.state.checkConfig[1] ? Units.toCanonicalSpeed(this.state.velocidadeSet, this.props.res) : 0,
          margin_up: Units.toCanonicalSpeed(this.state.velocidadeMargemUp.value, this.props.res),
          margin_down: Units.toCanonicalSpeed(this.state.velocidadeMargemDown.value, this.props.res),
          limit_up: Units.toCanonicalSpeed(this.state.velocidadeLimiteUp.value, this.props.res),
          limit_down: Units.toCanonicalSpeed(this.state.velocidadeLimiteDown.value, this.props.res),
        },
        {
          type: 'velocidadeV',
          set_a: Units.toCanonicalSpeed(this.state.velocidadeVSet, this.props.res),
          margin_up: Units.toCanonicalSpeed(this.state.velocidadeVMargemUp.value, this.props.res),
          margin_down: Units.toCanonicalSpeed(this.state.velocidadeVMargemDown.value, this.props.res),
          limit_up: Units.toCanonicalSpeed(this.state.velocidadeVLimiteUp.value, this.props.res),
          limit_down: Units.toCanonicalSpeed(this.state.velocidadeVLimiteDown.value, this.props.res),
        },
        this.props.res.LINGUA === 'en-US' ? {
          type: 'temperatura',
          set_a: tools.f_to_c(this.state.temperaturaSet),
          margin_up: tools.f_to_c(this.state.temperaturaSet + this.state.temperaturaMargemUp.value) - tools.f_to_c(this.state.temperaturaSet),
          margin_down: tools.f_to_c(this.state.temperaturaSet) - tools.f_to_c(this.state.temperaturaSet - this.state.temperaturaMargemDown.value),
          limit_up: tools.f_to_c(this.state.temperaturaSet + this.state.temperaturaMargemUp.value + this.state.temperaturaLimiteUp.value) -
            tools.f_to_c(this.state.temperaturaSet + this.state.temperaturaMargemUp.value),
          limit_down: tools.f_to_c(this.state.temperaturaSet - this.state.temperaturaMargemDown.value),
        } : {
          type: 'temperatura',
          set_a: this.state.temperaturaSet,
          margin_up: this.state.temperaturaMargemUp.value,
          margin_down: this.state.temperaturaMargemDown.value,
          limit_up: this.state.temperaturaLimiteUp.value,
          limit_down: this.state.temperaturaLimiteDown.value,
        },
      ];

      json = {
        name: this.state.name,
        rel_config: rel_config,
        type: 'analise',
        params: params.concat([{
          type: 'umidade',
          set_a: this.state.UmidadeSet,
          margin_up: this.state.UmidadeMargemUp.value,
          margin_down: this.state.UmidadeMargemDown.value,
          limit_up: this.state.UmidadeLimiteUp.value,
          limit_down: this.state.UmidadeLimiteDown.value,
        }, {
          type: 'angulo',
          set_a: 90,//VSetRight
          set_b: 270,//VSetLeft
          margin_up: this.state.espelharAnguloV ? this.state.anguloVMargemDown.value : this.state.anguloVMargemUp.value,
          margin_down: this.state.anguloVMargemDown.value,
          limit_up: this.state.espelharAnguloV ? this.state.anguloVLimiteDown.value : this.state.anguloVLimiteUp.value,
          limit_down: this.state.anguloVLimiteDown.value,
        }])
      };
    }

    let options = {
      method: method,
      body: JSON.stringify(json),
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json'
      },
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          let msg = this.props.res.ITEM_INCLUIR;
          if (this.state.id) {
            msg = this.props.res.ITEM_ALTERADO;
          }
          notification.open({
            message: this.props.res.SUCESSO,
            description: msg,
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          this.props.link('/app/cadastro/perfil_auto/list')
        },
        (error) => {
          this.setState({ progress: false });
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          } else if (error.status === 400) {
            error.json().then(
              (errCode) => {
                notification.open({
                  message: this.props.res[errCode.code],
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              });
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );

  }

  handleToggle = (value) => () => {
    const currentIndex = this.state.checked.indexOf(value);
    const newChecked = [...this.state.checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState({ checked: newChecked });
  };

  changeSettingsMargemDown = (value, setValue, margemDown, limiteDown, margemUp) => {
    let temp_setValue = Number(this.state[setValue]);
    let temp_margemUp = this.state[margemUp];
    if (margemUp) {
      temp_setValue = (Number(temp_margemUp.text) - Number(value)) / 2 + Number(value);
    }
    let temp_margemDown = this.state[margemDown];
    temp_margemDown.text = value;
    if (!isNaN(value) &&
      Number(value) >= 0 &&
      (temp_setValue - Number(value)) >= 0) {
      temp_margemDown.valid = true;
      temp_margemDown.value = (temp_setValue - Number(value));
      let temp_limiteDown = this.state[limiteDown];
      let temp = (temp_setValue - this.state[margemDown].value - this.state[limiteDown].value);
      if (temp < 0) {
        temp_limiteDown.value = temp === 0 ? 0 : this.state[limiteDown].value + temp;
        if (temp_limiteDown.valid) temp_limiteDown.text = value - temp_limiteDown.value;
      }
      temp_limiteDown.text = (temp_setValue - temp_margemDown.value - temp_limiteDown.value);
      let update = { [margemDown]: temp_margemDown, [limiteDown]: temp_limiteDown, [setValue]: temp_setValue };
      if (margemUp) {
        temp_margemUp.value = Number(temp_margemUp.text) - temp_setValue;
        update[margemUp] = temp_margemUp;
      }
      this.setState(update);
    } else {
      temp_margemDown.valid = false;
      this.setState({ [margemDown]: temp_margemDown });
    }
  };
  changeSettingsMargemUp = (value, setValue, margemUp, limiteUp, limitMax, margemDown) => {
    let temp_setValue = Number(this.state[setValue]);
    let temp_margemDown = this.state[margemDown];
    if (margemDown) {
      temp_setValue = (Number(value) - Number(temp_margemDown.text)) / 2 + Number(temp_margemDown.text);
    }
    let temp_margemUp = this.state[margemUp];
    temp_margemUp.text = value;
    if (!isNaN(value) &&
      ((limitMax && (temp_setValue + Number(value)) <= limitMax) || !limitMax) &&
      (Number(value) - temp_setValue) >= 0) {
      temp_margemUp.value = (Number(value) - temp_setValue);
      temp_margemUp.valid = true;
      let temp_limiteUp = this.state[limiteUp];
      if (limitMax && (temp_setValue + temp_margemUp.value + temp_limiteUp.value) > limitMax) {
        temp_limiteUp.value = limitMax - temp_margemUp.value;
      }
      temp_limiteUp.text = temp_setValue + temp_margemUp.value + temp_limiteUp.value;
      let update = { [margemUp]: temp_margemUp, [limiteUp]: temp_limiteUp, [setValue]: temp_setValue };
      if (margemDown) {
        temp_margemDown.value = temp_setValue - Number(temp_margemDown.text);
        update[margemDown] = temp_margemDown;
      }
      this.setState(update);
    } else {
      temp_margemUp.valid = false;
      this.setState({ [margemUp]: temp_margemUp });
    }
  };
  changeSettingsLimitDown = (value, setValue, margemDown, limiteDown) => {
    let temp_limitDown = this.state[limiteDown];
    temp_limitDown.text = value;
    if (!isNaN(value) &&
      Number(value) >= 0 &&
      Number(value) <= (Number(this.state[setValue]) - Number(this.state[margemDown].value))) {
      temp_limitDown.value = (Number(this.state[setValue]) - Number(this.state[margemDown].value) - Number(value))
      temp_limitDown.text = value;
      temp_limitDown.valid = true;
      this.setState({ [limiteDown]: temp_limitDown });
    } else {
      temp_limitDown.valid = false;
      this.setState({ [limiteDown]: temp_limitDown });
    }
  };
  changeSettingsLimitUp = (value, setValue, margemUp, limiteUp, limitMax) => {
    let temp_value = Number(value);
    let temp_setValue = Number(this.state[setValue]);
    let temp_margemUp = Number(this.state[margemUp].value);
    let temp_limiteUp = this.state[limiteUp];
    temp_limiteUp.text = value;
    if (!isNaN(value) &&
      ((limitMax && (temp_value) <= limitMax) || !limitMax) &&
      (temp_value) >= (temp_margemUp + temp_setValue)) {

      temp_limiteUp.value = (temp_value - (temp_setValue + temp_margemUp));
      temp_limiteUp.valid = true;
      this.setState({ [limiteUp]: temp_limiteUp });
    } else {
      temp_limiteUp.valid = false;
      this.setState({ [limiteUp]: temp_limiteUp });
    }
  };
  changeType = (config, set, limiteDown, margemDown, margemUp, limiteUp) => ev => {
    if (config) {
      const setValue = ev ? Number(ev.target.value) : this.state[set];
      this.state[limiteDown].text = setValue - (this.state[margemDown].value + this.state[limiteDown].value);
      this.state[margemDown].text = setValue - this.state[margemDown].value;
      this.state[margemUp].text = setValue + this.state[margemUp].value;
      this.state[limiteUp].text = setValue + this.state[margemUp].value + this.state[limiteUp].value;
    } else {
      this.state[limiteDown].text = 0 - (this.state[margemDown].value + this.state[limiteDown].value);
      this.state[margemDown].text = 0 - this.state[margemDown].value;
      this.state[margemUp].text = 0 + this.state[margemUp].value;
      this.state[limiteUp].text = 0 + this.state[margemUp].value + this.state[limiteUp].value;
    }
    let state = {
      [limiteDown]: this.state[limiteDown],
      [margemDown]: this.state[margemDown],
      [margemUp]: this.state[margemUp],
      [limiteUp]: this.state[limiteUp],
    };
    if (ev) {
      state[set] = ev.target.value;
    }
    this.setState(state);
  };

  styleTitle = { marginTop: '1rem', width: 'auto', height: '2.3rem', marginBottom: '-1.5rem', textDecoration: 'underline', textAlign: 'center' };
  montaItem = (label, config, set, limitDown, maginDown, maginUp, limitUp) => {
    return <div className="divContentItem">
      <div><h4 style={this.styleTitle}>{label[0].toUpperCase()}</h4></div>
      <div style={{ marginBottom: '-1rem' }}>
        <FormControl
          style={{ padding: ".4rem 0 .4rem 0" }}
          className={this.props.classes.textField}
          fullWidth
          component="fieldset">
          <RadioGroup id="tipo_pessoa" aria-label="pessoa" name="pessoa1" value={this.state.checkConfig[config]}
            onChange={(ev) => {
              this.state.checkConfig[config] = Number(ev.target.value);
              this.setState({ checkConfig: this.state.checkConfig },
                this.changeType(this.state.checkConfig[config], set, limitDown, maginDown, maginUp, limitUp)
              );
            }}
          >
            <FormControlLabel value={0} control={<Radio color="primary" />} label={'Configuração da Aeronave'} />
            <FormControlLabel value={1} control={<Radio color="primary" />} label={'Configuração fixa'} />
          </RadioGroup>
          <TextField
            style={{ width: '9rem', position: 'absolute', left: '11rem', top: '3.5rem' }}
            disabled={!this.state.checkConfig[config]}
            value={this.state[set]}
            onChange={this.changeType(this.state.checkConfig[config], set, limitDown, maginDown, maginUp, limitUp)}
            type="number"
          />
        </FormControl>
      </div>
      <BarHeat values={this.state.checkConfig[config] ? [
        Number(this.state[set]) - (this.state[maginDown].value + this.state[limitDown].value),
        Number(this.state[set]) - this.state[maginDown].value,
        Number(this.state[set]),
        Number(this.state[set]) + this.state[maginUp].value,
        Number(this.state[set]) + this.state[maginUp].value + this.state[limitUp].value
      ] : [
        0 - (this.state[maginDown].value + this.state[limitDown].value),
        0 - this.state[maginDown].value,
        0,
        this.state[maginUp].value,
        this.state[maginUp].value + this.state[limitUp].value
      ]} />
      <div style={{ textAlign: 'center' }}>
        <TextField
          label={label[3]}
          value={Math.round(this.state[maginDown].text * 1000) / 1000}
          error={!this.state[maginDown].valid}
          onChange={this.changeMargemDown(this.state.checkConfig[config], set, maginDown, limitDown)}
          size="small"
          margin="dense"
          type="number"
          style={{ marginRight: '.5rem', width: '10rem' }}
        />
        <TextField
          label={label[4]}
          value={Math.round(this.state[maginUp].text * 1000) / 1000}
          error={!this.state[maginUp].valid}
          onChange={this.changeMargemUp(this.state.checkConfig[config], set, maginUp, limitUp)}
          size="small"
          margin="dense"
          InputProps={{
            startAdornment: this.state.checkConfig[config] || this.state[maginUp].text <= 0 ? null : <InputAdornment position="start" style={{ marginRight: '0', marginTop: '-.2rem' }}>+</InputAdornment>,
          }}
          type="number"
          style={{ width: '10rem' }}
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        <TextField
          label={label[5]}
          value={Math.round(this.state[limitDown].text * 1000) / 1000}
          error={!this.state[limitDown].valid}
          onChange={this.changeLimitDown(this.state.checkConfig[config], set, maginDown, limitDown)}
          size="small"
          margin="dense"
          type="number"
          style={{ marginRight: '.5rem', width: '10rem' }}
        />
        <TextField
          label={label[6]}
          value={Math.round(this.state[limitUp].text * 1000) / 1000}
          error={!this.state[limitUp].valid}
          onChange={this.changeLimitUp(this.state.checkConfig[config], set, maginUp, limitUp)}
          size="small"
          margin="dense"
          InputProps={{
            startAdornment: this.state.checkConfig[config] || this.state[limitUp].text <= 0 ? null : <InputAdornment position="start" style={{ marginRight: '0', marginTop: '-.2rem' }}>+</InputAdornment>,
          }}
          type="number"
          style={{ width: '10rem' }}
        />
      </div>
    </div>;
  }

  changeMargemUp = (config, set, margem, limit) => event => {
    let text = Number(event.target.value);
    this.state[margem].text = text;
    if (config) {
      let setValue = Number(this.state[set]);
      if (text >= 0 && setValue <= text) {
        this.state[margem].valid = true;
        this.state[margem].value = text - setValue;
        this.state[limit].text = setValue + this.state[margem].value + this.state[limit].value;
        this.setState({ [margem]: this.state[margem], [limit]: this.state[limit] });
      } else {
        this.state[margem].valid = false;
        this.setState({ [margem]: this.state[margem] });
      }
    } else {
      if (text < 0) {
        this.state[margem].valid = false;
        this.state[margem].value = 0;
      } else {
        this.state[margem].valid = true;
        this.state[margem].value = text;
      }
      this.state[limit].text = text + this.state[limit].value;
      this.setState({ [margem]: this.state[margem], [limit]: this.state[limit] });
    }
  };
  changeMargemDown = (config, set, margem, limit) => event => {
    let text = Number(event.target.value);
    this.state[margem].text = text;
    if (config) {
      let setValue = Number(this.state[set]);
      if (text >= 0 && setValue >= text) {
        this.state[margem].valid = true;
        this.state[margem].value = setValue - text;
        this.state[limit].text = setValue - this.state[margem].value - this.state[limit].value;
        this.state[limit].valid = this.state[limit].text < 0 ? false : true;
        this.setState({ [margem]: this.state[margem], [limit]: this.state[limit] });
      } else {
        this.state[margem].valid = false;
        this.setState({ [margem]: this.state[margem] });
      }
    } else {
      if (text > 0) {
        this.state[margem].valid = false;
        this.state[margem].value = 0;
      } else {
        this.state[margem].valid = true;
        this.state[margem].value = text * -1;
      }
      this.state[limit].text = text - this.state[limit].value;
      this.setState({ [margem]: this.state[margem], [limit]: this.state[limit] });
    }
  };
  changeLimitUp = (config, set, margem, limit) => event => {
    let value = Number(event.target.value);
    this.state[limit].text = value;
    if (value < this.state[margem].text) {
      this.state[limit].valid = false;
    } else {
      this.state[limit].valid = true;
      this.state[limit].value = value - this.state[margem].text;
    }

    this.setState({ [limit]: this.state[limit] });
  };
  changeLimitDown = (config, set, margem, limit) => event => {
    let value = Number(event.target.value);
    this.state[limit].text = value;
    let setValue = Number(this.state[set]);
    if (config) {
      if (value > this.state[margem].text || value < 0) {
        this.state[limit].valid = false;
      } else {
        this.state[limit].valid = true;
        this.state[limit].value = this.state[margem].text - value;
      }
    } else {
      if (value > this.state[margem].text || value > 0) {
        this.state[limit].valid = false;
        this.state[limit].value = 0;
      } else {
        this.state[limit].valid = true;
        this.state[limit].value = value * -1 - this.state[margem].value;
      }
    }
    this.setState({ [limit]: this.state[limit] });
  }

  changeSize = (nome, value) => {
    this.setState({ [nome]: this.state[nome] + value });
  };

  render() {
    const { classes, link, res } = this.props;

    return (

      <form onSubmit={this.handleSubmit}>
        <div className="divContent">
          <div className="containerTop">
            <div><h1>{res.PERFIL_AUTOMACAO}</h1></div>
            <div className="centerTop"></div>
            <div>
              <Button variant="contained" onClick={evemt => { link('/app/cadastro/perfil_auto/list') }} className="popUpButton">
                {res.CANCELAR}
              </Button> &nbsp;
              <Button type="submit" variant="contained" color="primary" className="popUpButton">
                <SaveIcon className="iconMapS" />
                {res.SALVAR}
              </Button>
            </div>
          </div>
          <div>
            <h2 style={{ marginLeft: '.5rem' }}>
              {this.state.type === 'analise'
                ? res.QUALIDADE
                : (this.state.type === 'planejamento'
                  ? res.PLANEJAMENTO
                  : (this.state.type === 'ordem_servico'
                    ? res.ORDEM_SERVICO
                    : (this.state.type === 'relatorio_mapa'
                      ? (res.RELATORIO_MAPA)
                      : res.RELATORIO_APLICACAO)))}
            </h2>
          </div>

          <div className="form-group notTooBig">
            <FormControl style={{ width: '100%' }}>
              <TextField
                required
                id="name"
                label={res.NOME}
                className={classes.textField}
                value={this.state.name}
                onChange={this.handleChange('name')}
                margin="normal"
                fullWidth
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 45)
                }}
              />
              {this.state.type === 'planejamento' && (
                <>
                  <div style={{ margin: '1rem 0.5rem' }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAutoPlan}
                            onChange={() => this.setState({ checkAutoPlan: !this.state.checkAutoPlan })}
                          />
                        }
                        label={(res.PLANEJAMENTO_AUTOMATICO)}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAutoMerge}
                            onChange={() => this.setState({ checkAutoMerge: !this.state.checkAutoMerge })}
                          />
                        }
                        label={(res.MERGE_AUTOMATICO)}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAlignPivot}
                            onChange={() => this.setState({ checkAlignPivot: !this.state.checkAlignPivot })}
                          />
                        }
                        label={(res.ALIGN_PIVOT)}
                      />                      
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAutoSend}
                            onChange={() => this.setState({ checkAutoSend: !this.state.checkAutoSend })}
                          />
                        }
                        label={(res.ENVIAR_PLANEJAMENTO)}
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAutoMatch}
                            onChange={() => this.setState({ checkAutoMatch: !this.state.checkAutoMatch })}
                          />
                        }
                        label={(res.COMPARAR_TITULOS)}
                      />
                    </FormGroup>

                    <div style={{ marginTop: '1.5rem' }}>
                      <FormControl style={{ width: '100%' }}>
                        <InputLabel htmlFor="planningStrategyMode">
                          {res.ESTRATEGIA_PLANEJAMENTO}
                        </InputLabel>
                        <Select
                          value={this.state.planningStrategyMode}
                          onChange={this.handleChange('planningStrategyMode')}
                          inputProps={{
                            id: 'planningStrategyMode',
                          }}
                        >
                          <MenuItem value="tempo">
                            {res.POR_TEMPO}
                          </MenuItem>
                          <MenuItem value="faixas">
                            {res.POR_FAIXAS}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    <div style={{ marginTop: '1.5rem' }}>
                      <h3 style={{ marginBottom: '1rem' }}>
                        {res.CONFIGURACAO_ESTRATEGIAS}
                      </h3>

                      {[
                        { key: 'BACKTOBACK', label: 'Back to Back' },
                        { key: 'SKIPBACKTOBACK', label: 'Skip Back to Back' },
                        { key: 'RACETRACK', label: 'Racetrack' },
                        { key: 'QUICKRACETRACK', label: 'Quick Racetrack' },
                        { key: 'REVERSERACETRACK', label: 'Reverse Racetrack' },
                        { key: 'SQUEEZE', label: 'Squeeze' },
                        { key: 'EXPAND', label: 'Expand' }
                      ].map((item) => (
                        <div
                          key={item.key}
                          style={{
                            border: '1px solid #dcdcdc',
                            borderRadius: '6px',
                            padding: '1rem',
                            marginBottom: '1rem',
                            opacity: this.state.planningStrategyMode === 'faixas' ? 1 : 0.65,
                            background: this.state.planningStrategyMode === 'faixas' ? '#fff' : '#f7f7f7'
                          }}
                        >
                          <div style={{ fontWeight: 'bold', marginBottom: '.8rem', textAlign: 'center' }}>
                            {item.label}
                          </div>

                          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                            <TextField
                              label={res.MINIMO_FAIXAS}
                              value={
                                this.state.planningStrategyRanges &&
                                  this.state.planningStrategyRanges[item.key]
                                  ? this.state.planningStrategyRanges[item.key].min
                                  : ''
                              }
                              onChange={(e) => {
                                const planningStrategyRanges = { ...this.state.planningStrategyRanges };
                                if (!planningStrategyRanges[item.key]) {
                                  planningStrategyRanges[item.key] = { min: '', max: '', noMax: false };
                                }

                                planningStrategyRanges[item.key].min = e.target.value;

                                if (!e.target.value) {
                                  planningStrategyRanges[item.key].noMax = false;
                                }

                                this.setState({ planningStrategyRanges });
                              }}
                              type="number"
                              size="small"
                              margin="dense"
                              style={{ width: '12rem' }}
                              disabled={this.state.planningStrategyMode !== 'faixas'}
                              onInput={(e) => {
                                e.target.value = e.target.value.toString().slice(0, 4)
                              }}
                            />

                            <TextField
                              label={res.MAXIMO_FAIXAS}
                              value={
                                this.state.planningStrategyRanges &&
                                  this.state.planningStrategyRanges[item.key]
                                  ? this.state.planningStrategyRanges[item.key].max
                                  : ''
                              }
                              onChange={(e) => {
                                const planningStrategyRanges = { ...this.state.planningStrategyRanges };
                                if (!planningStrategyRanges[item.key]) {
                                  planningStrategyRanges[item.key] = { min: '', max: '', noMax: false };
                                }

                                planningStrategyRanges[item.key].max = e.target.value;

                                if (e.target.value) {
                                  planningStrategyRanges[item.key].noMax = false;
                                }

                                this.setState({ planningStrategyRanges });
                              }}
                              type="number"
                              size="small"
                              margin="dense"
                              style={{ width: '12rem' }}
                              disabled={
                                this.state.planningStrategyMode !== 'faixas' ||
                                (
                                  this.state.planningStrategyRanges &&
                                  this.state.planningStrategyRanges[item.key] &&
                                  this.state.planningStrategyRanges[item.key].noMax
                                )
                              }
                              onInput={(e) => {
                                e.target.value = e.target.value.toString().slice(0, 4)
                              }}
                            />

                            {this.state.planningStrategyRanges &&
                              this.state.planningStrategyRanges[item.key] &&
                              this.state.planningStrategyRanges[item.key].min &&
                              !this.state.planningStrategyRanges[item.key].max ? (
                              <FormControlLabel
                                style={{ marginLeft: 0, whiteSpace: 'nowrap' }}
                                disabled={this.state.planningStrategyMode !== 'faixas'}
                                control={
                                  <Checkbox
                                    color="primary"
                                    checked={
                                      this.state.planningStrategyRanges[item.key] &&
                                        this.state.planningStrategyRanges[item.key].noMax
                                        ? true
                                        : false
                                    }
                                    onChange={(e) => {
                                      const planningStrategyRanges = { ...this.state.planningStrategyRanges };

                                      if (!planningStrategyRanges[item.key]) {
                                        planningStrategyRanges[item.key] = { min: '', max: '', noMax: false };
                                      }

                                      planningStrategyRanges[item.key].noMax = e.target.checked;

                                      if (e.target.checked) {
                                        planningStrategyRanges[item.key].max = '';
                                      }

                                      this.setState({ planningStrategyRanges });
                                    }}
                                  />
                                }
                                label={
                                  (res.MAIOR_QUE) +
                                  ' ' +
                                  this.state.planningStrategyRanges[item.key].min
                                }
                              />
                            ) : null}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {this.state.type === 'ordem_servico' && (
                <>
                  <div style={{ margin: '1rem 0.5rem' }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAutoShare}
                            onChange={() => this.setState({ checkAutoShare: !this.state.checkAutoShare })}
                          />
                        }
                        label={(res.COMPARTILHAR_AUTOMATICO_OS)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAutoReturn}
                            onChange={() => this.setState({ checkAutoReturn: !this.state.checkAutoReturn })}
                          />
                        }
                        label={(res.RETORNAR_AUTOMATICO_OS)}
                      />
                    </FormGroup>
                  </div>
                </>
              )}
              {this.state.type === 'relatorio_mapa' && (
                <>
                  <div style={{ margin: '1rem 0.5rem' }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkMapaFundoMapa}
                            onChange={() => this.setState({ checkMapaFundoMapa: !this.state.checkMapaFundoMapa })}
                          />
                        }
                        label={res.MAPA_FUNDO}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkAplicacaoMapa}
                            onChange={() => this.setState({ checkAplicacaoMapa: !this.state.checkAplicacaoMapa })}
                          />
                        }
                        label={res.APLICACAO}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkTrajetoriaMapa}
                            onChange={() => this.setState({ checkTrajetoriaMapa: !this.state.checkTrajetoriaMapa })}
                          />
                        }
                        label={res.TRAJETORIA_VOO}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkRemoverLogoMapa}
                            onChange={() => this.setState({ checkRemoverLogoMapa: !this.state.checkRemoverLogoMapa })}
                          />
                        }
                        label={res.REMOVER_LOGO}
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.checkGuiaAplicacaoMapa}
                            onChange={() => this.setState({ checkGuiaAplicacaoMapa: !this.state.checkGuiaAplicacaoMapa })}
                          />
                        }
                        label={res.GUIA_APLICACAO}
                      />
                    </FormGroup>
                  </div>
                </>
              )}
              {this.state.type === 'aplicacao' && (
                <>
                  < div style={{ textAlign: 'start', margin: '1rem 0.5rem' }}>
                    <h3>{res.LARGURA_FAIXA}</h3>
                    <Button className={"buttonS buttonMenu"} disabled={this.state.percSize <= 50} onClick={event => this.changeSize('percSize', -10)}>
                      <SvgIcon viewBox="0 -960 960 960" className="iconMapP" style={{ color: this.state.percSize <= 50 ? '#b9b9b9' : 'black' }} >
                        <path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm384-16v-80h320v80H600Z" />
                      </SvgIcon>
                    </Button>
                    <label style={{ margin: '.2rem' }}>  {this.state.percSize}%  </label>
                    <Button className={"buttonS buttonMenu"} disabled={this.state.percSize >= 150} onClick={event => this.changeSize('percSize', 10)}>
                      <SvgIcon viewBox="0 -960 960 960" className="iconMapP" style={{ color: this.state.percSize >= 150 ? '#b9b9b9' : 'black' }} >
                        <path d="m40-200 210-560h100l210 560h-96l-51-143H187l-51 143H40Zm176-224h168l-82-232h-4l-82 232Zm504 104v-120H600v-80h120v-120h80v120h120v80H800v120h-80Z" />
                      </SvgIcon>
                    </Button>
                  </div>
                  <div style={{ margin: '2rem 0.5rem' }}>
                    <h3 style={{ display: 'block', marginBottom: 8, textAlign: 'start' }}>
                      {res.PARAMETROS_RELATORIO_APLICACAO}:
                    </h3>
                    <div style={{ marginBottom: '1rem' }}>

                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkWhatsAppAplicacao}
                              onChange={() =>
                                this.setState({ checkWhatsAppAplicacao: !this.state.checkWhatsAppAplicacao })
                              }
                            />
                          }
                          label={res.RECEBER_WPP}
                        />
                      </FormGroup>

                      <h4 style={{ marginBottom: 6 }}>{res.MAPA}</h4>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkTrajetoria}
                              onChange={() =>
                                this.setState({ checkTrajetoria: !this.state.checkTrajetoria })
                              }
                            />
                          }
                          label={res.TRAJETORIA_VOO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkPoligono}
                              onChange={() =>
                                this.setState({ checkPoligono: !this.state.checkPoligono })
                              }
                            />
                          }
                          label={res.POLIGONO_APLICADO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkPoligonoLimpo}
                              onChange={() =>
                                this.setState({ checkPoligonoLimpo: !this.state.checkPoligonoLimpo })
                              }
                            />
                          }
                          label={res.POLIGONO_NAO_APLICADO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkMapa}
                              onChange={() =>
                                this.setState({ checkMapa: !this.state.checkMapa })
                              }
                            />
                          }
                          label={res.MAPA_FUNDO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkCoordenadas}
                              onChange={() =>
                                this.setState({ checkCoordenadas: !this.state.checkCoordenadas })
                              }
                            />
                          }
                          label={`${res.CAMADA_COORDENADAS}`}
                        />
                      </FormGroup>
                    </div>

                    <div>
                      <h4 style={{ marginBottom: 6 }}>{res.TRABALHO}</h4>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkVazao}
                              onChange={() =>
                                this.setState({ checkVazao: !this.state.checkVazao })
                              }
                            />
                          }
                          label={res.VAZAO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkVolume}
                              onChange={() =>
                                this.setState({ checkVolume: !this.state.checkVolume })
                              }
                            />
                          }
                          label={res.VOLUME_APLICADO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkAltura}
                              onChange={() =>
                                this.setState({ checkAltura: !this.state.checkAltura })
                              }
                            />
                          }
                          label={res.ALTURA}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkCliente}
                              onChange={() =>
                                this.setState({ checkCliente: !this.state.checkCliente })
                              }
                            />
                          }
                          label={res.NOME_CLIENTE}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkAeronave}
                              onChange={() =>
                                this.setState({ checkAeronave: !this.state.checkAeronave })
                              }
                            />
                          }
                          label={res.PREFIXO_AERONAVE}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkClima}
                              onChange={() =>
                                this.setState({ checkClima: !this.state.checkClima })
                              }
                            />
                          }
                          label={res.VARIAVEIS_CLIMA}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkVelocidade}
                              onChange={() =>
                                this.setState({ checkVelocidade: !this.state.checkVelocidade })
                              }
                            />
                          }
                          label={res.VELOCIDADE}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkFaixa}
                              onChange={() =>
                                this.setState({ checkFaixa: !this.state.checkFaixa })
                              }
                            />
                          }
                          label={res.FAIXA_APLICACAO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkEstenderTiro}
                              onChange={() =>
                                this.setState({ checkEstenderTiro: !this.state.checkEstenderTiro })
                              }
                            />
                          }
                          label={res.ESTENDER_TIRO}
                        />
                      </FormGroup>
                    </div>
                    <div>
                      <h4 style={{ marginBottom: 6 }}>{res.PARAMETROS_RELATORIO_RESUMIDO}</h4>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoTitulo}
                              onChange={() => this.setState({ checkResumoTitulo: !this.state.checkResumoTitulo })}
                            />
                          }
                          label={res.TITULO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoCliente}
                              onChange={() => this.setState({ checkResumoCliente: !this.state.checkResumoCliente })}
                            />
                          }
                          label={res.CLIENTE}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoPropriedade}
                              onChange={() => this.setState({ checkResumoPropriedade: !this.state.checkResumoPropriedade })}
                            />
                          }
                          label={res.PROPRIEDADE}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoArea}
                              onChange={() => this.setState({ checkResumoArea: !this.state.checkResumoArea })}
                            />
                          }
                          label={res.AREA_TOTAL_APLICADA}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoFaixa}
                              onChange={() => this.setState({ checkResumoFaixa: !this.state.checkResumoFaixa })}
                            />
                          }
                          label={res.FAIXA_APP}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoVazao}
                              onChange={() => this.setState({ checkResumoVazao: !this.state.checkResumoVazao })}
                            />
                          }
                          label={res.VAZAO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoInicio}
                              onChange={() => this.setState({ checkResumoInicio: !this.state.checkResumoInicio })}
                            />
                          }
                          label={res.INICIO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoFim}
                              onChange={() => this.setState({ checkResumoFim: !this.state.checkResumoFim })}
                            />
                          }
                          label={res.FIM}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoAeronave}
                              onChange={() => this.setState({ checkResumoAeronave: !this.state.checkResumoAeronave })}
                            />
                          }
                          label={res.AERONAVE}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoPiloto}
                              onChange={() => this.setState({ checkResumoPiloto: !this.state.checkResumoPiloto })}
                            />
                          }
                          label={res.PILOTO}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoTalhoes}
                              onChange={() => this.setState({ checkResumoTalhoes: !this.state.checkResumoTalhoes })}
                            />
                          }
                          label={res.TALHOES_}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoLatLng}
                              onChange={() => this.setState({ checkResumoLatLng: !this.state.checkResumoLatLng })}
                            />
                          }
                          label={`${res.LATITUDE} / ${res.LONGITUDE}`}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={this.state.checkResumoAlturaCultura}
                              onChange={() => this.setState({ checkResumoAlturaCultura: !this.state.checkResumoAlturaCultura })}
                            />
                          }
                          label={`${res.ALTURA_CULTURA}`}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </>
              )}
              {this.state.type === 'analise' && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    margin: '1rem 0.5rem'
                  }}
                >
                  <div style={{ width: '12.4rem', height: '5rem', textAlign: 'center' }}>
                    <h3>{res.LARGURA_FAIXA_ESTENDIDA}</h3>

                    < Button className={"buttonS buttonMenu"} disabled={this.state.larguraExd <= 100} onClick={event => this.changeSize('larguraExd', -5)}>
                      {'-'}
                    </Button>
                    <label style={{ margin: '.2rem' }}>  {this.state.larguraExd}%  </label>
                    < Button className={"buttonS buttonMenu"} disabled={this.state.larguraExd >= 130} onClick={event => this.changeSize('larguraExd', 5)}>
                      {'+'}
                    </Button>
                  </div>
                  <h3 style={{ display: 'block', marginBottom: 8, textAlign: 'start' }}>{res.PARAMETROS_RELATORIO}:</h3>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkWhatsAppQuali}
                        onChange={() => this.setState({ checkWhatsAppQuali: !this.state.checkWhatsAppQuali })}
                      />
                    }
                    label={res.RECEBER_WPP}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoCobertura}
                        onChange={() => this.setState({ checkResumoCobertura: !this.state.checkResumoCobertura })}
                      />
                    }
                    label="Cobertura"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoAltura}
                        onChange={() => this.setState({ checkResumoAltura: !this.state.checkResumoAltura })}
                      />
                    }
                    label="Altura"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoFluxo}
                        onChange={() => this.setState({ checkResumoFluxo: !this.state.checkResumoFluxo })}
                      />
                    }
                    label="Fluxo"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoVelocidade}
                        onChange={() => this.setState({ checkResumoVelocidade: !this.state.checkResumoVelocidade })}
                      />
                    }
                    label="Velocidade"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoVelocidadeVento}
                        onChange={() => this.setState({ checkResumoVelocidadeVento: !this.state.checkResumoVelocidadeVento })}
                      />
                    }
                    label="Velocidade do Vento"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoAnguloVento}
                        onChange={() => this.setState({ checkResumoAnguloVento: !this.state.checkResumoAnguloVento })}
                      />
                    }
                    label="Angulo de Desvio do Vento"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoTemperatura}
                        onChange={() => this.setState({ checkResumoTemperatura: !this.state.checkResumoTemperatura })}
                      />
                    }
                    label="Temperatura"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoUmidade}
                        onChange={() => this.setState({ checkResumoUmidade: !this.state.checkResumoUmidade })}
                      />
                    }
                    label="Umidade"
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={this.state.checkResumoDeltat}
                        onChange={() => this.setState({ checkResumoDeltat: !this.state.checkResumoDeltat })}
                      />
                    }
                    label="Delta-T"
                  />
                </div>
              )}
            </FormControl>
          </div>
        </div >
        {
          this.state.type === 'analise' && (
            <>
              <div key={'teste'}>
                <div
                  style={{
                    paddingBottom: '1rem',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                </div>
              </div>
              <div key={'teste1'}>
                <h3
                  style={{
                    marginBottom: '1rem',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                  }}
                >
                  {'AERONAVE'}
                </h3>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '.5rem',
                    paddingBottom: '1rem',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  {this.montaItem([res.ALTURA, res.TOLERANCIA_ALTURA_MIN, res.TOLERANCIA_ALTURA_MAX, res.LIMITE_ALTURA_MIN, res.LIMITE_ALTURA_MAX],
                    0, 'alturaSet', 'alturaLimiteDown', 'alturaMargemDown', 'alturaMargemUp', 'alturaLimiteUp')}
                  {this.montaItem([res.FLUXO, res.TOLERANCIA_FLUXO_MIN, res.TOLERANCIA_FLUXO_MAX, res.LIMITE_FLUXO_MIN, res.LIMITE_FLUXO_MAX],
                    2, 'fluxoSet', 'fluxoLimiteDown', 'fluxoMargemDown', 'fluxoMargemUp', 'fluxoLimiteUp')}
                  {this.montaItem([res.VELOCIDADE, res.TOLERANCIA_VELOCIDADE_MIN, res.TOLERANCIA_VELOCIDADE_MAX, res.LIMITE_VELOCIDADE_MIN, res.LIMITE_VELOCIDADE_MAX],
                    1, 'velocidadeSet', 'velocidadeLimiteDown', 'velocidadeMargemDown', 'velocidadeMargemUp', 'velocidadeLimiteUp')}
                </div>
              </div>
              <div key={'teste2'}>
                <h3
                  style={{
                    marginBottom: '1rem',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                  }}
                >
                  {'CLIMA'}
                </h3>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '.5rem',
                    paddingBottom: '1rem',
                    borderBottom: '1px solid lightgray',
                  }}
                >
                  <div className="divContentItem">
                    <div style={{ position: 'relative' }}>
                      <div><h4 style={this.styleTitle}>{tools.replaceString(res._VELOCIDADE_VENTO, Units.getSpeedUnit(res)).toUpperCase()}</h4></div>
                      <BarHeat values={[
                        Number(this.state.velocidadeVSet) - this.state.velocidadeVMargemDown.value - this.state.velocidadeVLimiteDown.value,
                        Number(this.state.velocidadeVSet) - this.state.velocidadeVMargemDown.value,
                        null,//Number(this.state.velocidadeVSet),
                        Number(this.state.velocidadeVSet) + this.state.velocidadeVMargemUp.value,
                        Number(this.state.velocidadeVSet) + this.state.velocidadeVMargemUp.value + this.state.velocidadeVLimiteUp.value
                      ]} grayZero={true} res={res} />
                      <div style={{ textAlign: 'center' }}>
                        <TextField
                          label={res.TOLERANCIA_VELOCIDADE_VENTO_MIN}
                          value={Math.round(this.state.velocidadeVMargemDown.text * 1000) / 1000}
                          error={!this.state.velocidadeVMargemDown.valid}
                          onChange={(event) => {
                            this.changeSettingsMargemDown(
                              event.target.value,
                              'velocidadeVSet',
                              'velocidadeVMargemDown',
                              'velocidadeVLimiteDown',
                              'velocidadeVMargemUp',
                            );
                          }}
                          size="small"
                          margin="dense"
                          type="number"
                          style={{ marginRight: '.5rem' }}
                        />
                        <TextField
                          label={res.TOLERANCIA_VELOCIDADE_MAX}
                          value={Math.round(this.state.velocidadeVMargemUp.text * 1000) / 1000}
                          error={!this.state.velocidadeVMargemUp.valid}
                          onChange={(event) => {
                            this.changeSettingsMargemUp(
                              event.target.value,
                              'velocidadeVSet',
                              'velocidadeVMargemUp',
                              'velocidadeVLimiteUp',
                              null,
                              'velocidadeVMargemDown'
                            );
                          }}
                          size="small"
                          margin="dense"
                          type="number"
                        />
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <TextField
                          label={res.LIMITE_VELOCIDADE_MIN}
                          value={Math.round(this.state.velocidadeVLimiteDown.text * 1000) / 1000}
                          error={!this.state.velocidadeVLimiteDown.valid}
                          onChange={(event) => {
                            this.changeSettingsLimitDown(
                              event.target.value,
                              'velocidadeVSet',
                              'velocidadeVMargemDown',
                              'velocidadeVLimiteDown'
                            );
                          }}
                          size="small"
                          margin="dense"
                          type="number"
                          style={{ marginRight: '.5rem' }}
                        />
                        <TextField
                          label={res.LIMITE_VELOCIDADE_MAX}
                          value={Math.round(this.state.velocidadeVLimiteUp.text * 1000) / 1000}
                          error={!this.state.velocidadeVLimiteUp.valid}
                          onChange={(event) => {
                            this.changeSettingsLimitUp(
                              event.target.value,
                              'velocidadeVSet',
                              'velocidadeVMargemUp',
                              'velocidadeVLimiteUp'
                            );
                          }}
                          size="small"
                          margin="dense"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="divContentItem" style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', right: '0px', top: '4rem', zIndex: '1', userSelect: 'none' }}>
                      <span onClick={(ev) => { this.setState({ espelharAnguloV: !this.state.espelharAnguloV }) }} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                        {res.ESPELHAR}
                      </span>
                      <Checkbox
                        checked={this.state.espelharAnguloV}
                        onClick={(ev) => { this.setState({ espelharAnguloV: !this.state.espelharAnguloV }) }}
                      />
                    </div>
                    <div><h4 style={this.styleTitle}>{res.ANGULO_DESVIO_VENTO_UNI.toUpperCase()}</h4></div>
                    <div style={{
                      width: '23.45rem',
                      margin: '-.5rem'
                    }}>
                      <PlaneHeat type="P" ckey="0" values={[
                        Number(this.state.anguloVLimiteDown.value),
                        Number(this.state.anguloVMargemDown.value),
                        Number(this.state.anguloVSet),
                        this.state.espelharAnguloV ? Number(this.state.anguloVMargemDown.value) : Number(this.state.anguloVMargemUp.value),
                        this.state.espelharAnguloV ? Number(this.state.anguloVLimiteDown.value) : Number(this.state.anguloVLimiteUp.value)
                      ]} limit="90" res={res} />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <TextField
                        label={res.TOLERANCIA_ANGULO_VENTO_MIN}
                        value={Math.round(this.state.anguloVMargemDown.text * 1000) / 1000}
                        error={!this.state.anguloVMargemDown.valid}
                        onChange={(event) => {
                          this.changeSettingsMargemUp(
                            event.target.value,
                            'anguloVSet',
                            'anguloVMargemDown',
                            'anguloVLimiteDown',
                            90
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                        style={{ marginRight: '.5rem' }}
                      />
                      <TextField
                        label={res.TOLERANCIA_ANGULO_VENTO_MAX}
                        value={this.state.espelharAnguloV ?
                          Math.round(this.state.anguloVMargemDown.text * 1000) / 1000 :
                          Math.round(this.state.anguloVMargemUp.text * 1000) / 1000}
                        error={!this.state.anguloVMargemUp.valid}
                        onChange={(event) => {
                          this.changeSettingsMargemUp(
                            event.target.value,
                            'anguloVSet',
                            'anguloVMargemUp',
                            'anguloVLimiteUp',
                            90
                          );
                        }}
                        size="small"
                        margin="dense"
                        disabled={this.state.espelharAnguloV}
                        type="number"
                      />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <TextField
                        label={res.LIMITE_ANGULO_VENTO_MIN}
                        value={Math.round(this.state.anguloVLimiteDown.text * 1000) / 1000}
                        error={!this.state.anguloVLimiteDown.valid}
                        onChange={(event) => {
                          this.changeSettingsLimitUp(
                            event.target.value,
                            'anguloVSet',
                            'anguloVMargemDown',
                            'anguloVLimiteDown',
                            90
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                        style={{ marginRight: '.5rem' }}
                      />
                      <TextField
                        label={res.LIMITE_ANGULO_VENTO_MAX}
                        value={this.state.espelharAnguloV ?
                          Math.round(this.state.anguloVLimiteDown.text * 1000) / 1000 :
                          Math.round(this.state.anguloVLimiteUp.text * 1000) / 1000}
                        error={!this.state.anguloVLimiteUp.valid}
                        onChange={(event) => {
                          this.changeSettingsLimitUp(
                            event.target.value,
                            'anguloVSet',
                            'anguloVMargemUp',
                            'anguloVLimiteUp',
                            90
                          );
                        }}
                        size="small"
                        margin="dense"
                        disabled={this.state.espelharAnguloV}
                        type="number"
                      />
                    </div>
                  </div>
                  <div className="divContentItem">
                    <div><h4 style={this.styleTitle}>{res.DELTA_T.toUpperCase()}</h4></div>
                    <div style={{ marginLeft: '-.7rem' }}>
                      <DeltaTHeat values={this.state} temperatura_values={[
                        Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value - this.state.temperaturaLimiteDown.value,
                        Number(this.state.temperaturaSet) - this.state.temperaturaMargemDown.value,
                        null, //Number(this.state.temperaturaSet),
                        Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value,
                        Number(this.state.temperaturaSet) + this.state.temperaturaMargemUp.value + this.state.temperaturaLimiteUp.value
                      ]} humidade_values={[
                        Number(this.state.UmidadeSet) - this.state.UmidadeMargemDown.value - this.state.UmidadeLimiteDown.value,
                        Number(this.state.UmidadeSet) - this.state.UmidadeMargemDown.value,
                        null, //Number(this.state.UmidadeSet),
                        Number(this.state.UmidadeSet) + this.state.UmidadeMargemUp.value,
                        Number(this.state.UmidadeSet) + this.state.UmidadeMargemUp.value + this.state.UmidadeLimiteUp.value
                      ]}
                        res={res} />
                    </div>
                    <div><h4 style={this.styleTitle}>{tools.replaceString(res._TEMPERATURA_UNI, res.LINGUA === 'en-US' ? res.F : res.C).toUpperCase()}</h4></div>
                    <div style={{ textAlign: 'center' }}>
                      <TextField
                        label={res.TOLERANCIA_TEMPERATURA_MIN}
                        value={Math.round(this.state.temperaturaMargemDown.text * 1000) / 1000}
                        error={!this.state.temperaturaMargemDown.valid}
                        onChange={(event) => {
                          this.changeSettingsMargemDown(
                            event.target.value,
                            'temperaturaSet',
                            'temperaturaMargemDown',
                            'temperaturaLimiteDown',
                            'temperaturaMargemUp',
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                        style={{ marginRight: '.5rem' }}
                      />
                      <TextField
                        label={res.TOLERANCIA_TEMPERATURA_MAX}
                        value={Math.round(this.state.temperaturaMargemUp.text * 1000) / 1000}
                        error={!this.state.temperaturaMargemUp.valid}
                        onChange={(event) => {
                          this.changeSettingsMargemUp(
                            event.target.value,
                            'temperaturaSet',
                            'temperaturaMargemUp',
                            'temperaturaLimiteUp',
                            null,
                            'temperaturaMargemDown',
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                      />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <TextField
                        label={res.LIMITE_TEMPERATURA_MIN}
                        value={Math.round(this.state.temperaturaLimiteDown.text * 1000) / 1000}
                        error={!this.state.temperaturaLimiteDown.valid}
                        onChange={(event) => {
                          this.changeSettingsLimitDown(
                            event.target.value,
                            'temperaturaSet',
                            'temperaturaMargemDown',
                            'temperaturaLimiteDown',
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                        style={{ marginRight: '.5rem' }}
                      />
                      <TextField
                        label={res.LIMITE_TEMPERATURA_MAX}
                        value={Math.round(this.state.temperaturaLimiteUp.text * 1000) / 1000}
                        error={!this.state.temperaturaLimiteUp.valid}
                        onChange={(event) => {
                          this.changeSettingsLimitUp(
                            event.target.value,
                            'temperaturaSet',
                            'temperaturaMargemUp',
                            'temperaturaLimiteUp'
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                      />
                    </div>
                    <div><h4 style={this.styleTitle}>{res.HUMIDADE_UNI.toUpperCase()}</h4></div>
                    <div style={{ textAlign: 'center' }}>
                      <TextField
                        label={res.TOLERANCIA_HUMIDADE_MIN}
                        value={Math.round(this.state.UmidadeMargemDown.text * 1000) / 1000}
                        error={!this.state.UmidadeMargemDown.valid}
                        onChange={(event) => {
                          this.changeSettingsMargemDown(
                            event.target.value,
                            'UmidadeSet',
                            'UmidadeMargemDown',
                            'UmidadeLimiteDown',
                            'UmidadeMargemUp',
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                        style={{ marginRight: '.5rem' }}
                      />
                      <TextField
                        label={res.TOLERANCIA_HUMIDADE_MAX}
                        value={Math.round(this.state.UmidadeMargemUp.text * 1000) / 1000}
                        error={!this.state.UmidadeMargemUp.valid}
                        onChange={(event) => {
                          this.changeSettingsMargemUp(
                            event.target.value,
                            'UmidadeSet',
                            'UmidadeMargemUp',
                            'UmidadeLimiteUp',
                            null,
                            'UmidadeMargemDown',
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                      />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <TextField
                        label={res.LIMITE_HUMIDADE_MIN}
                        value={Math.round(this.state.UmidadeLimiteDown.text * 1000) / 1000}
                        error={!this.state.UmidadeLimiteDown.valid}
                        onChange={(event) => {
                          this.changeSettingsLimitDown(
                            event.target.value,
                            'UmidadeSet',
                            'UmidadeMargemDown',
                            'UmidadeLimiteDown'
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                        style={{ marginRight: '.5rem' }}
                      />
                      <TextField
                        label={res.LIMITE_HUMIDADE_MAX}
                        value={Math.round(this.state.UmidadeLimiteUp.text * 1000) / 1000}
                        error={!this.state.UmidadeLimiteUp.valid}
                        onChange={(event) => {
                          this.changeSettingsLimitUp(
                            event.target.value,
                            'UmidadeSet',
                            'UmidadeMargemUp',
                            'UmidadeLimiteUp'
                          );
                        }}
                        size="small"
                        margin="dense"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        }
      </form >
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { id } = useParams();
  return (
    <div className="rowForm">

      <TextFields1 link={link} id={id} res={res} />

    </div>)
}

export default Box;
